// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/images/background/bg_default_1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.genieclass-dashboard-container::before,
.genieclass-recorded-lesson-container::before {
  content: ' ';
  position: fixed;
  left: 0px;
  top: 4rem;
  z-index: -10;
  height: calc(100% + 76px);
  width: 100vw;
  --tw-bg-opacity: 1;
  background-color: rgb(22 19 62 / var(--tw-bg-opacity));
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: cover;
  background-attachment: fixed;
  background-position: 6.5% 41%;
  background-repeat: no-repeat;
}

.genieclass-dashboard-container::-webkit-scrollbar,
.genieclass-recorded-lesson-container::-webkit-scrollbar {
  display: none;
}

.genieclass-dashboard-container,
.genieclass-recorded-lesson-container {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow-y: hidden;
}
`, "",{"version":3,"sources":["webpack://./src/app/pages/online_lesson/GenieclassDashboard.css"],"names":[],"mappings":"AAAA;;EAEE,YAAY;EACZ,eAAe;EACf,SAAS;EACT,SAAS;EACT,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,sDAAsD;EACtD,yDAAmE;EACnE,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,wBAAwB,EAAE,gBAAgB;EAC1C,qBAAqB,EAAE,YAAY;EACnC,kBAAkB;AACpB","sourcesContent":[".genieclass-dashboard-container::before,\n.genieclass-recorded-lesson-container::before {\n  content: ' ';\n  position: fixed;\n  left: 0px;\n  top: 4rem;\n  z-index: -10;\n  height: calc(100% + 76px);\n  width: 100vw;\n  --tw-bg-opacity: 1;\n  background-color: rgb(22 19 62 / var(--tw-bg-opacity));\n  background-image: url('@assets/images/background/bg_default_1.svg');\n  background-size: cover;\n  background-attachment: fixed;\n  background-position: 6.5% 41%;\n  background-repeat: no-repeat;\n}\n\n.genieclass-dashboard-container::-webkit-scrollbar,\n.genieclass-recorded-lesson-container::-webkit-scrollbar {\n  display: none;\n}\n\n.genieclass-dashboard-container,\n.genieclass-recorded-lesson-container {\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n  overflow-y: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
